import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import toast from 'react-hot-toast';
import useAuth from '../../../hooks/useAuth';
import { publicRequest } from '../../../configs/axios';
import { API_ENDPOINTS } from '../../../configs/api.config';
import styles from './AddReview.module.css';

const initialFormState = {
  subject: '',
  description: '',
};

const AddReview = () => {
  const { loggedInUser } = useAuth();
  const [formData, setFormData] = useState(initialFormState);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const toastId = toast.loading('Sending your message...');

    const contactData = {
      firstName: loggedInUser.firstName,
      lastName: loggedInUser.lastName,
      email: loggedInUser.email,
      subject: formData.subject,
      message: formData.description,
    };

    try {
      await publicRequest.post(API_ENDPOINTS.CONTACT, contactData);
      toast.dismiss(toastId);
      toast.success('Your message has been sent successfully!');
      setFormData(initialFormState);
    } catch (error) {
      toast.dismiss(toastId);
      toast.error(error.response?.data?.message || 'Failed to send message. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id={styles.add__review}>
      <Container>
        <h1>Communicate with Agent Ziyadha</h1>
        <p>Have a question or need assistance? We're here to help. Please fill out the form below and we'll get back to you shortly.</p>

        <Row>
          <Col lg={8} md={10} className="mx-auto">
            <form onSubmit={handleSubmit}>
              {/* User Info (Read-only) */}
              <div className={styles.user__info}>
                <div className={styles.info__field}>
                  <strong>Name:</strong> {loggedInUser.firstName} {loggedInUser.lastName}
                </div>
                <div className={styles.info__field}>
                  <strong>Email:</strong> {loggedInUser.email}
                </div>
              </div>

              {/* Subject Field */}
              <div className={styles.span__input}>
                <label htmlFor="subject">Subject</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  autoComplete="off"
                  spellCheck="false"
                  placeholder="Enter your subject"
                  required
                />
              </div>

              {/* Description Field */}
              <div className={styles.span__input}>
                <label htmlFor="description">Description</label>
                <textarea
                  id="description"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  cols="20"
                  rows="7"
                  placeholder="Write your message or feedback here"
                  required
                ></textarea>
              </div>

              {/* Submit Button */}
              <button type="submit" disabled={loading}>
                {loading ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AddReview;
